import {accent, greenColors, neutral} from './designSystem';

const fieldFocusRing = '0 0 0 2px rgba(85, 104, 114, 0.28)';

interface FieldStyleTheme {
  palette: {
    text: {primary: string};
  };
}

export const getFieldStyle = (theme: FieldStyleTheme, backgroundVariant?: 'light' | 'dark') => {
  void backgroundVariant;
  const backgroundColor = '#ffffff';

  return {
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      backgroundColor,
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: greenColors[5],
      },
      '& fieldset': {
        borderColor: neutral[200],
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: accent.main,
      },
      '&.Mui-focused': {
        backgroundColor,
        boxShadow: fieldFocusRing,
      },
      '&.Mui-focused fieldset': {
        borderColor: accent.main,
        borderWidth: '1px',
      },
      '&.Mui-disabled': {
        backgroundColor: neutral['black-50'],
      },
      '&.Mui-disabled fieldset': {
        borderColor: neutral[200],
      },
      '& .MuiOutlinedInput-input': {
        caretColor: theme.palette.text.primary,
        fontSize: '14px',
      },
      '& .MuiOutlinedInput-input.Mui-disabled': {
        color: neutral[300],
        WebkitTextFillColor: neutral[300],
      },
    },
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
      fontSize: '13px',
      '&.Mui-focused': {
        color: theme.palette.text.primary,
      },
    },
  };
};
